import React from 'react'

export default function Title({ title }) {
    return (
        <div className='contetn_titel'>
            <h2>
                {title}
            </h2>
        </div>
    )
}
